import { useToasts } from 'react-toast-notifications'

function useToaster() {
    return useToasts();
}
export default useToaster;